export default {"src":"/assets/turbo/ef70a3d2/ackermannch/_next/static/media/favicon.c39a2a5c.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};